import { toZonedTime } from "date-fns-tz";
import Config from "../config.ts";
import { addHours, format } from "date-fns";

export const getDateFromString = (isoDate: string) => {
  const utcDate = new Date(isoDate);
  const zonedDate = toZonedTime(utcDate, Config.TIME_ZONE);

  return format(zonedDate, "dd/MM/yyyy");
};

export const getDatePartFromDate = (date: Date) => format(date, "dd/MM/yyyy");

export const getTimeFromISODate = (isoDate: string) => {
  const utcDate = new Date(isoDate);
  const zonedDate = toZonedTime(utcDate, Config.TIME_ZONE);

  return format(zonedDate, "HH:mm");
};

export const fixCalendarDate = (date: Date) => {
  return addHours(date, 10);
};
